import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brown text-cream/60 py-12 px-4 text-center" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <h3 className="text-2xl font-serif text-cream mb-4" data-id="element-26">
          Plan Pancita Desinflamada
        </h3>
        <p className="text-sm mb-8 max-w-md mx-auto" data-id="element-27">
          El método práctico para recuperar tu ligereza abdominal sin dietas
          imposibles.
        </p>

        <div className="w-16 h-px bg-cream/20 mx-auto mb-8" data-id="element-28" />

        <div className="text-xs space-y-2" data-id="element-29">
          <p data-id="element-30">Este producto no sustituye el consejo médico profesional.</p>
          <p data-id="element-31">
            &copy; {currentYear} Plan Pancita Desinflamada. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}